import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { StarIcon, CheckCircleIcon, ShieldCheckIcon, DownloadIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-16 pb-10 md:pt-24 md:pb-16 bg-navy text-white overflow-hidden" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-162">
          {/* Left Column: Copy */}
          <FadeIn direction="right" data-id="element-163">
            <div className="flex items-center gap-2 mb-4" data-id="element-164">
              <div className="flex text-gold" data-id="element-165">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-166" />)}
              </div>
              <span className="text-sm font-medium text-gray-300" data-id="element-167">
                Más de <strong data-id="element-168">10,000</strong> lectores satisfechos
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading leading-tight mb-4" data-id="element-169">
              Comprende los <span className="text-gold" data-id="element-170">66 Libros</span> de la
              Biblia en menos de <span className="text-gold" data-id="element-171">7 dias</span> con
              un viaje visual de Más de{' '}
              <span className="underline decoration-gold decoration-2 underline-offset-4" data-id="element-172">
                280 Imágenes HD
              </span>
            </h1>

            <p className="text-base md:text-lg text-gray-300 mb-5 leading-relaxed" data-id="element-173">
              Descubre <strong data-id="element-174">EXACTAMENTE</strong> dónde ocurrió cada
              acontecimiento bíblico y logra con estas{' '}
              <strong data-id="element-175">+500 Paginas</strong> de contexto visual que{' '}
              <span className="bg-gold/20 px-1 rounded" data-id="element-176">
                cada versículo cobre vida frente a tus ojos
              </span>
              .
            </p>

            <div className="flex flex-wrap gap-2 mb-5 text-sm font-medium text-gold-400" data-id="element-177">
              <span className="flex items-center gap-1 bg-navy-800 px-3 py-1 rounded-full border border-navy-700" data-id="element-178">
                <CheckCircleIcon className="w-4 h-4" data-id="element-179" /> Imágenes en Alta
                Resolución
              </span>
              <span className="flex items-center gap-1 bg-navy-800 px-3 py-1 rounded-full border border-navy-700" data-id="element-180">
                <CheckCircleIcon className="w-4 h-4" data-id="element-181" /> 66 Libros
              </span>
              <span className="flex items-center gap-1 bg-navy-800 px-3 py-1 rounded-full border border-navy-700" data-id="element-182">
                <CheckCircleIcon className="w-4 h-4" data-id="element-183" /> 500+ Páginas
              </span>
            </div>

            <div className="space-y-3" data-id="element-184">
              <Button fullWidth className="md:w-auto md:px-12 py-4 text-lg" data-id="element-185">
                QUIERO MI BIBLIA VISUAL
              </Button>

              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 text-xs text-gray-400" data-id="element-186">
                <span className="flex items-center gap-1" data-id="element-187">
                  <DownloadIcon className="w-3.5 h-3.5" data-id="element-188" /> Descarga inmediata
                </span>
                <span className="hidden md:inline" data-id="element-189">•</span>
                <span className="flex items-center gap-1" data-id="element-190">
                  <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-191" /> Pago único
                </span>
                <span className="hidden md:inline" data-id="element-192">•</span>
                <span className="flex items-center gap-1" data-id="element-193">
                  <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-194" /> Garantía 30 días
                </span>
              </div>
            </div>
          </FadeIn>

          {/* Right Column: Product Image */}
          <FadeIn direction="left" delay={0.15} data-id="element-195">
            <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-196">
              <div className="absolute inset-0 bg-gold opacity-20 blur-3xl rounded-full" data-id="element-197"></div>
              <img src="https://cdn.magicpatterns.com/uploads/7W4nqbUiDbetU6MEa6EzSE/20260225_1349_Image_Generation_simple_compose_01kjav77w8f2wrzq7hhc4dkpn4.png" alt="Biblia Visual — Libro, iPad con línea de tiempo bíblica, teléfono con versículo diario, flashcards teológicas y más" className="relative w-full rounded-2xl shadow-2xl object-cover" data-id="element-198" />
            </div>
          </FadeIn>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="mt-10 border-t border-navy-800 bg-navy-900/50" data-id="element-199">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5" data-id="element-200">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-201">
            <FadeIn delay={0.2} data-id="element-202">
              <div className="text-2xl md:text-3xl font-bold text-gold font-heading mb-0.5" data-id="element-203">
                280+
              </div>
              <div className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-204">
                Imágenes HD
              </div>
            </FadeIn>
            <FadeIn delay={0.25} data-id="element-205">
              <div className="text-2xl md:text-3xl font-bold text-gold font-heading mb-0.5" data-id="element-206">
                66
              </div>
              <div className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-207">
                Libros Cubiertos
              </div>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-208">
              <div className="text-2xl md:text-3xl font-bold text-gold font-heading mb-0.5" data-id="element-209">
                500+
              </div>
              <div className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-210">
                Páginas
              </div>
            </FadeIn>
            <FadeIn delay={0.35} data-id="element-211">
              <div className="text-2xl md:text-3xl font-bold text-gold font-heading mb-0.5" data-id="element-212">
                7
              </div>
              <div className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-213">
                Bonos Gratis
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}